const DOMAIN =
  window.location.hostname === 'localhost' ||
  window.location.hostname === 'app-dev.qualisflow.com'
    ? 'https://newadmin-dev.qualisflow.com'
    : 'https://newadmin.qualisflow.com'

export const RECORD = {
  EDIT: `${DOMAIN}/accounts/:accountId/projects/:projectId/:moduleName/record/:recordId/edit`
}
